import React from 'react';
import QuestionList from "./QuestionList";
import {Route, Switch, withRouter} from "react-router-dom";
import {connect} from "react-redux";

import QuestionForm from "./QuestionForm";
import QuestionPreview from "./QuestionPreview";
import QuestionImageForm from "./QuestionImageForm";

import './style.css';
import {
    addQuestion,
    editQuestion,
    editQuestionImage,
    enableQuestion,
    removeQuestion
} from '../../redux/actions/questionActions';

class Questions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            size: {
                width: 200,
                height: 200
            }
        };

        this.handleAddQuestion = this.handleAddQuestion.bind(this);
        this.handleEditQuestion = this.handleEditQuestion.bind(this);
        this.handleChangeEnabled = this.handleChangeEnabled.bind(this);
        this.handleAddQuestionImage = this.handleAddQuestionImage.bind(this);
        this.handleRemoveQuestion = this.handleRemoveQuestion.bind(this);
    }

    handleAddQuestion(values) {
        const { sessionData, fceAddQuestion } = this.props;
        const callback = () => {
            this.props.history.push('/questions');
        };
        if (sessionData) {
            fceAddQuestion(sessionData.accessToken, values, callback)
        }
    }

    handleEditQuestion(questionId, values) {
        const { sessionData, fceEditQuestion } = this.props;
        if (sessionData) {
            fceEditQuestion(sessionData.accessToken, questionId, values)
        }
    }

    handleChangeEnabled(question){
        const { sessionData, fceEnableQuestion } = this.props;
        if (sessionData) {
            fceEnableQuestion(sessionData.accessToken, question)
        }
    }

    handleAddQuestionImage(values) {
        const { sessionData, fceEditQuestionImage } = this.props;
        if (sessionData) {
            fceEditQuestionImage(sessionData.accessToken, values)
        }
    }

    handleRemoveQuestion(question) {
        const { sessionData, fceRemoveQuestion } = this.props;
        const callback = () => {
            this.props.history.push('/questions');
        };
        if (sessionData) {
            fceRemoveQuestion(sessionData.accessToken, question, callback)
        }
    }

    render() {
        return (
            <div id="question-page" className="right-col" role="main">
                <div className="page-title">
                    <h3>Otázky</h3>
                </div>
                <Switch>
                    <Route exact path="/questions" component={() =>
                        <QuestionList
                            {...this.props}
                            handleRemoveQuestion={this.handleRemoveQuestion}
                            handleChangeEnabled={this.handleChangeEnabled}
                        />
                    }
                    />
                    <Route path="/questions/preview/:id" component={() =>
                        <QuestionPreview
                            {...this.props}
                        />
                    }
                    />
                    <Route path="/questions/add" component={() =>
                        <QuestionForm
                            {...this.props}
                            title="Přidat otázku"
                            button="Přidat"
                            action={this.handleAddQuestion}
                        />
                    }
                    />
                    <Route path="/questions/edit/:id" component={() =>
                        <QuestionForm
                            {...this.props}
                            title="Úprava otázky"
                            button="Upravit"
                            action={this.handleEditQuestion}
                        />
                    }
                    />
                    <Route path="/questions/image/:id" component={() =>
                        <QuestionImageForm
                            {...this.props}
                            title="Přidání obrázku k otázce"
                            button="Uložit"
                            size={this.state.size}
                            action={this.handleAddQuestionImage}
                        />
                    }
                    />
                </Switch>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    notifications: state.notifications,
});

const mapDispatchToProps = (dispatch) => ({
    fceAddQuestion: (token, values, callback) => dispatch(addQuestion(token, values, callback)),
    fceEditQuestion: (token, questionId, values, callback) => dispatch(editQuestion(token, questionId, values, callback)),
    fceRemoveQuestion: (token, question, callback) => dispatch(removeQuestion(token, question, callback)),
    fceEnableQuestion: (token, question) => dispatch(enableQuestion(token, question)),
    fceEditQuestionImage: (token, values) => dispatch(editQuestionImage(token, values))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Questions));



/** WEBPACK FOOTER **
 ** ./src/containers/Questions/index.js
 **/